import {getLoginMenuList} from '../../libs/utils';
import {getUserInfo, setUserInfo, getMenu, setMenu} from '../../libs/storage';
import router from "../../router/router";

export default {
  state: {
    access: localStorage.getItem('access') ? localStorage.getItem('access') : null,// 登录成功以后，当前用户拥有的权限的数据
    userInfo: getUserInfo() || {}, // 用户信息
    isCollapse: false, // 右侧菜单伸缩
    // menuList: getMenu() || [], // 右侧的显示的菜单栏的数据
    menuList: [], // 右侧的显示的菜单栏的数据
    operates: null, // 页面权限
  },
  getters: {
    menuList(state, getters, rootState) {
      let list = [
        ...rootState.user.menuList,
      ];
      return getLoginMenuList(list, router[4].children, rootState.user.access);
      // return getLoginMenuList(router, rootState.user.access);
    },
    userInfo(state, getters, rootState) {
      return rootState.user.userInfo;
    },
    userOperates(state, getters, rootState) {
      return rootState.user.operates;
    },
  },
  mutations: {
    // 设置 用户信息
    SET_USERINFO: (state, data) => {
      setUserInfo(data);
      // Vue.set(state, 'userInfo', data);
      state.userInfo = {
        ...data
      };
    },
    // 设置 右侧菜单伸缩
    SET_ISCOLLAPSE: (state, data) => {
      state.isCollapse = !state.isCollapse;
    },
    SET_MENULIST: (state, data) => {
      setMenu(data);
      state.menuList = [].concat(data);
    },
    SET_OPERATES: (state, data) => {
      state.operates = [].concat(data);
    }
  },
  actions: {
    // 保存用户的信息
    SaveUserInfo({ commit }, data) {
      commit('SET_USERINFO', data);
    },
    // 保存用户的信息
    UpdateIsCollapse({ commit }, data) {
      commit('SET_ISCOLLAPSE', data);
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js